import { TableCell } from "@mui/material";
import {
  IAdditional,
  IAdditionalHeaderProps,
} from "../../TableTemplate/tableTemplate";
import { IIncrementalReport } from "../../../Interfaces/deltaHedgeExe";
import { useState } from "react";
import Button from "../../../Components/Button";
import Modal from "../../../Components/Modal/Modal";
import ChancesTable from "./ChancesTable";
import OrdersTable from "./OrdersTable";

const AdditionalHeader = ({}: IAdditionalHeaderProps) => {
  return (
    <>
      <TableCell />
      <TableCell />
    </>
  );
};

enum ModalMode {
  Chances,
  Orders,
  Closed,
}

const AdditionalCol: React.FC<{
  row: IIncrementalReport;
  onAction: () => void;
}> = ({ row, onAction }) => {
  const [modalMode, setModalMode] = useState(ModalMode.Closed);

  const getModalUI = () => {
    switch (modalMode) {
      case ModalMode.Chances:
        return <ChancesTable searchParams={{ ins: row.ins, user: row.user }} />;

      case ModalMode.Orders:
        return <OrdersTable searchParams={{ ins: row.ins, user: row.user }} />;

      case ModalMode.Closed:
        return <></>;
    }
  };

  return (
    <>
      <TableCell>
        {modalMode !== ModalMode.Closed ? (
          <Modal
            UI={getModalUI()}
            onClose={() => setModalMode(ModalMode.Closed)}
          />
        ) : (
          <></>
        )}
        <div className="w-16">
          <Button
            text="شانس ها"
            variant="contained"
            className="table-btn"
            onClick={() => setModalMode(ModalMode.Chances)}
          />
        </div>
      </TableCell>

      <TableCell>
        <div className="w-16">
          <Button
            text="سفارشات"
            variant="contained"
            className="table-btn"
            onClick={() => setModalMode(ModalMode.Orders)}
          />
        </div>
      </TableCell>
    </>
  );
};

export const Additional: IAdditional<IIncrementalReport> = {
  getHeader: AdditionalHeader,
  getRow: AdditionalCol,
};
